import { Autocomplete, TextField } from "@mui/material";
import LayersIcon from "@mui/icons-material/Layers";
import { OptionCard } from "../../../common-ui/OptionCard";
import {
  Dispatch,
  HTMLAttributes,
  MouseEventHandler,
  SetStateAction
} from "react";
import { useTranslation } from "react-i18next";
import { AssessmentSummaryProgram } from "../../Activities/activitiesAPI";

type ProgramCardProps = {
  program: AssessmentSummaryProgram;
  props?: HTMLAttributes<HTMLLIElement>;
  selected?: boolean;
  clearable?: boolean;
  disabled?: boolean;
  setSelectedProgram: Dispatch<SetStateAction<AssessmentSummaryProgram | undefined>>;
  isMenuItem?: boolean;
  autoCompleteOnClick?: MouseEventHandler<HTMLLIElement> | undefined;
};

const ProgramCard = ({
  program,
  props,
  selected,
  clearable,
  disabled,
  setSelectedProgram,
  isMenuItem,
  autoCompleteOnClick
}: ProgramCardProps) => {
  return (
    <OptionCard
      avatarContent={<LayersIcon />}
      passedProps={props}
      title={program.name}
      subtitle={program.institutionName ?? "N/A"}
      setOption={setSelectedProgram}
      selected={selected}
      clearable={clearable && !disabled}
      disabled={disabled}
      isMenuItem={isMenuItem}
      autoCompleteOnClick={autoCompleteOnClick}
    />
  );
};

type ProgramSelectProps = {
  disabled?: boolean;
  sharedPrograms: AssessmentSummaryProgram[];
  selectedProgram?: AssessmentSummaryProgram;
  setSelectedProgram: Dispatch<
    SetStateAction<AssessmentSummaryProgram | undefined>
  >;
};

export const ProgramSelect = ({
  disabled,
  sharedPrograms,
  selectedProgram,
  setSelectedProgram
}: ProgramSelectProps) => {
  const { t } = useTranslation();

  if (selectedProgram) {
    return (
      <ProgramCard
        program={selectedProgram}
        setSelectedProgram={setSelectedProgram}
        selected
        clearable
        disabled={disabled}
      />
    );
  }

  return (
    <Autocomplete
      disabled={disabled}
      options={sharedPrograms}
      id="program-select-input"
      getOptionLabel={(option) => option.name}
      renderOption={(props, option) => (
        <ProgramCard
          key={option.id}
          program={option}
          props={props}
          setSelectedProgram={setSelectedProgram}
          isMenuItem
          autoCompleteOnClick={props.onClick}
        />
      )}
      renderInput={(params) => {
        return <TextField {...params} label={t("Confirm Program")} />;
      }}
      onChange={(event, value, reason) => {
        if (reason === "selectOption" && value) {
          setSelectedProgram(value);
        }
      }}
    />
  );
};
